export const BACKEND_URL = 'https://marketoapi.connect.capabilitysource.com'
export const OAUTH_CLIENT_ID = 'f377e1dafce792f95e388193fea22a20'
